// extracted by mini-css-extract-plugin
module.exports = {"skillContainer":"skills_skillContainer__1Hm1H"};